module.exports = __webpack_public_path__ + "static/media/About.890557be.svg";